<div class="header">
  <div>
    Add Rules For: <span class="cameraName">{{ data.camera.name }}</span>
  </div>
  <sn-icon-button icon="close" mat-dialog-close=""></sn-icon-button>
</div>
<div mat-dialog-content>
  <div class="formContainer">
    <div class="insideWrapper">
      <sn-audit-camera-stream-view
        [camera]="data.camera"
        [autoplay]="true"
        [controls]="false"
        [timestamp]="false"
        [actions]="false"
        (stateChange)="onStateChange($event)"
      >
      </sn-audit-camera-stream-view>
      <svg
        id="aiGridCanvas"
        xmlns="http://www.w3.org/2000/svg"
        class="coveringCanvas"
        [attr.height]="svgHeight"
        [attr.width]="svgWidth"
        (mouseup)="handleMouseUp($event)"
        (mousemove)="handleMouseMove($event)"
      >
        <defs>
          <pattern
            *ngIf="gridX && gridY"
            id="grid"
            [attr.width]="gridX"
            [attr.height]="gridY"
            patternUnits="userSpaceOnUse"
          >
            <path d="M 10 0 L 0 0 0 10" fill="none" stroke="white" stroke-width="1" opacity="0.5" />
          </pattern>
        </defs>
        <rect id="gridRect" width="100%" height="100%" fill="url(#grid)" />
      </svg>
    </div>
    <div class="form">
      <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
      <div class="customZoneContainer" *ngIf="!zoneDrawn">
        <img
          src="http://0002d18cc7ac.fususcam.com/VCA/www/static/img/Tutorial-draw-detection-area.a795d993.gif"
          alt=""
          srcset=""
        />
        <span class="customZone">Draw A Customized Zone</span>
      </div>
      <div *ngIf="zoneDrawn">
        <div
          *ngIf="
            selectedSchedule === 'repeated_schedule' && currentRule !== 'vca_smart_motion_detection'
          "
        >
          <ul class="listHeader">
            <li>Day</li>
            <li>Start Time</li>
            <li>End Time</li>
            <li>Actions</li>
          </ul>
          <hr />
          <div *ngFor="let item of timeAndDay; let i = index">
            <ul class="listItems">
              <li>{{ item.day }}</li>
              <li>{{ item.start }}</li>
              <li>{{ item.end }}</li>
              <li>
                <sn-icon-button>
                  <sn-icon fontSet="fal" fontIcon="fa-pen" (click)="editTimeAndDay(item)"></sn-icon>
                </sn-icon-button>
                <sn-icon-button>
                  <sn-icon
                    fontSet="fal"
                    fontIcon="fa-trash"
                    (click)="deleteTimeAndDay(i)"
                  ></sn-icon>
                </sn-icon-button>
              </li>
            </ul>
          </div>
          <sn-button color="success" (click)="addTimeAndDay()">
            <sn-icon>add</sn-icon>
            Add Day and Time
          </sn-button>
        </div>
        <sn-form
          [form]="formGenerated"
          [fields]="formFieldsGenerated"
          [model]="formModelGenerated"
        ></sn-form>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <sn-button [disabled]="!drawing && !zoneDrawn" color="warning" (click)="reset()">
    reset
  </sn-button>
  <sn-button color="success" type="submit" [disabled]="form.invalid" (click)="submit()"
    >Submit</sn-button
  >
</div>
